import React from "react";

function Blogsw({ colorCode = "" }) {
  return (
    <svg className="MuiSvgIcon-root" viewBox="0 0 21 19" fill={colorCode}>
      <path
        d="M3.85 18.9H17.5C18.444 18.855 19.3344 18.448 19.9862 17.7637C20.638 17.0793 21.0011 16.1701 21 15.225V9.1H15.75V2.45C15.75 1.80022 15.4919 1.17705 15.0324 0.717588C14.5729 0.258124 13.9498 0 13.3 0H2.45C1.80022 0 1.17705 0.258124 0.717588 0.717588C0.258124 1.17705 0 1.80022 0 2.45V15.05C0 16.0711 0.405624 17.0503 1.12764 17.7724C1.84965 18.4944 2.82892 18.9 3.85 18.9ZM18.9 11.2V15.225C18.9 15.6427 18.7341 16.0433 18.4387 16.3387C18.1433 16.6341 17.7427 16.8 17.325 16.8C16.9073 16.8 16.5067 16.6341 16.2113 16.3387C15.9159 16.0433 15.75 15.6427 15.75 15.225V11.2H18.9ZM2.1 2.45C2.1 2.35717 2.13687 2.26815 2.20251 2.20251C2.26815 2.13687 2.35717 2.1 2.45 2.1H13.3C13.3928 2.1 13.4818 2.13687 13.5475 2.20251C13.6131 2.26815 13.65 2.35717 13.65 2.45V15.225C13.6476 15.7695 13.7672 16.3077 14 16.8H3.85C3.38587 16.8 2.94075 16.6156 2.61256 16.2874C2.28437 15.9592 2.1 15.5141 2.1 15.05V2.45Z"
        fill={colorCode}
      />
      <path
        d="M8.39995 12.5997H4.19995V14.6997H8.39995V12.5997Z"
        fill={colorCode}
      />
      <path
        d="M11.55 4.19989H4.19995V6.29989H11.55V4.19989Z"
        fill={colorCode}
      />
      <path
        d="M8.39995 12.5997H4.19995V14.6997H8.39995V12.5997Z"
        fill={colorCode}
      />
    </svg>
  );
}

export default Blogsw;
